<div #viewToggle class="calendar-body pb-2">
  <div class="row m-0 mt-2 mx-2 border-bottom-view" *ngFor="let event of listEventGroup">
    <div>
      <p class="mb-1">
        <i class="fa fa-square  pr-3 text-primary" aria-hidden="true"></i>
        <span class="font-weight-bold">{{event.dategroup | date: 'dd/MM/yyyy'}}</span>
      </p>
    </div>
    <div *ngFor="let item of event.items" class="pl-2  w-100 mb-2">
      <div class=" d-flex justify-content-between align-items-center row m-0 col-sm-12 p-0">
        <p class="mb-1">
          <i class="fa fa-square text-muted pr-3 f-9" aria-hidden="true"></i>
          <span class="badge-ticket badge p-1 mr-2 " [ngClass]="item?.tracker_name | badgeTracker">{{ '#' + item.tracker_name + ' '+ item.id}}</span>
        </p>
        <p class="mb-1">
          <span >{{item.due_date | date: 'dd/MM/yyyy'}}</span>
        </p>
      </div>
      <div class="mb-0 row m-0">
        <span class=" pl-2" [title]="item.subject">{{item.subject | truncate : 128}}</span>
      </div>
    </div>

  </div>
  <div *ngIf="listEventGroup?.length==0" class="text-center">
    <span class="text-muted font-italic">Chưa có dữ liệu hiển thị</span>
  </div>
<!--    <div *ngFor="let event of eventsList" #targetEl (click)="onViewEvent(event, $event, targetEl)"-->
<!--         class="calendar-event">-->
<!--        <div class="calendar-event__state" [ngStyle]="event?.style"></div>-->
<!--        <div class="calendar-event__content">-->
<!--            <div class="calendar-event__title">-->
<!--                {{event?.subject}}-->
<!--                <div class="calendar-event__progress" [style.color]="event?.statusColor">{{event?.statusText}}</div>-->
<!--            </div>-->
<!--            <div class="calendar-event__text">-->
<!--                <i class="fa fa-clock-o calendar-event__icon"></i>-->
<!--                {{event?.hourStr}}-->
<!--            </div>-->
<!--            <div *ngIf="event.location" class="calendar-event__text">-->
<!--                <i class="fa fa-map-marker calendar-event__icon"></i>-->
<!--                {{event?.location}}-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
</div>
